import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { getBranding$, getConfiguration$ } from '@vendasta/protos/partner/v1/whitelabel';

@Injectable({ providedIn: 'root' })
export class WhitelabelService {
  /** @deprecated Use BrandingV2Service to get partner branding instead */
  getBranding(partnerId: string, marketId?: string) {
    return getBranding$({ partnerId, marketId }).pipe(map((resp) => resp.branding!));
  }

  getConfiguration(partnerId: string, marketId?: string) {
    return getConfiguration$({ partnerId, marketId }).pipe(map((resp) => resp.configuration!));
  }
}
